import type { Communication } from "@medplum/fhirtypes";
import { COMMUNICATION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useCommunicationSubscription = createSubscriptionHook<Communication>(
  "Communication",
  COMMUNICATION_COLLECTION_NAME,
);
